// extracted by mini-css-extract-plugin
module.exports = {"body":"Members_body__2gRU8","cardBody":"Members_cardBody__3QyMi","table":"Members_table__12d4N"};